import type { NavigationHookAfter } from 'vue-router';
import { useAnalytics } from '../../domain/core/analytics/composables/useAnalytics';

export const trackPageView: NavigationHookAfter = (to, from) => {
  const { trackView } = useAnalytics();
  if (to.name !== from.name) {
    trackView(typeof to.name === 'string' ? `${to.name}` : to.path, to.path);
  }
};
